import { Height } from '@mui/icons-material';
import { blue, lightBlue } from '@mui/material/colors';
import React, { useState } from 'react';
import { MentionsInput, Mention } from 'react-mentions';

// const users = [
//     { id: 'alice', display: 'Alice' },
//     { id: 'bob', display: 'Bob' },
//     { id: 'charlie', display: 'Charlie' },
// ];

const basicStyle = (expanded) => ({
    control: {
        fontSize: 16,
        fontWeight: 'normal',
        padding: 10,
        border: '1px solid #ddd',
        borderRadius: 4,
        lineHeight: 1.5,
    },
    input: {
        padding: 10,
        fontSize: 16,
        fontWeight: 'normal',
        lineHeight: 1.5,
        outline: 0,
        border: 0,
        height: '100%'
    },
    '&multiLine': {
        control: {
            padding: 10,
            minHeight: expanded ? 100 : 40,
        },
        highlighter: {
            fontSize: 16,
            fontWeight: 'normal',
            lineHeight: 1.5,
        },
        input: {
            padding: 10,
            fontSize: 16,
            fontWeight: 'normal',
            lineHeight: 1.5,
            outline: 0,
            border: 0,
            height: '100%'
        },
    },
    suggestions: {
        list: {
            backgroundColor: 'white',
            border: '1px solid rgba(0,0,0,0.25)',
            fontSize: 14,
            boxShadow: '0 2px 4px rgba(0,0,0,0.2)',
        },
        item: {
            padding: '6px 12px',
            borderBottom: '1px solid rgba(0,0,0,0.1)',
            color: '#000',
            '&focused': {
                backgroundColor: blue[200],
                color: '#fff',
                fontWeight: 'bold',
            },
        },
    },
});



export default function MentionTextField({ handleExpand, expanded, content, setContent, mentions, setMentions, users }) {
    //const [value, setValue] = useState('');
    //const [mentions, setMentions] = useState([]);

    const handleChange = (event, markupValue, plainTextValue, mentionsArray) => {
        setContent(markupValue);
        setMentions(mentionsArray); // 👈 this is your array of mention objects
    };

    return (
        <MentionsInput
            value={content}
            onChange={handleChange}
            placeholder="Add a note..."
            style={basicStyle(expanded)}
            singleLine={false}
            onClick={handleExpand}
        >
            <Mention
                trigger="@"
                data={search => {
                    if (!search) return users;
                    return users.filter(user =>
                        user.display.toLowerCase().includes(search.toLowerCase())
                    );
                }}
                appendSpaceOnAdd={true}
                style={{ backgroundColor: blue[100] }}
            />
        </MentionsInput>
    );
}
